import { render, staticRenderFns } from "./StatisticHighlight.vue?vue&type=template&id=f131c28a&scoped=true&"
import script from "./StatisticHighlight.vue?vue&type=script&lang=js&"
export * from "./StatisticHighlight.vue?vue&type=script&lang=js&"
import style0 from "./StatisticHighlight.vue?vue&type=style&index=0&id=f131c28a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f131c28a",
  null
  
)

export default component.exports